module.exports = __webpack_public_path__ + "static/images/leaflet.draw/spritesheet-2x.png";